export const defaultPlugins = [
  '@tapjs/after',
  '@tapjs/after-each',
  '@tapjs/asserts',
  '@tapjs/before',
  '@tapjs/before-each',
  '@tapjs/chdir',
  '@tapjs/filter',
  '@tapjs/fixture',
  '@tapjs/intercept',
  '@tapjs/mock',
  '@tapjs/node-serialize',
  '@tapjs/snapshot',
  '@tapjs/spawn',
  '@tapjs/stdin',
  '@tapjs/typescript',
  '@tapjs/worker',
]
